export const formatUserListTable = (data) => {
  return data.map((item) => {
    // Helper function to format work_days
    const formatWorkDays = (workDays) => {
      if (!workDays) return null;
      if (Array.isArray(workDays)) return workDays;
      if (typeof workDays === "object") {
        // Get the first key's value (like "Offline" days)
        const days = Object.values(workDays)[0];
        return Array.isArray(days) ? days : null;
      }
      return null;
    };

    return {
      key: `user-list-user-${
        item.partition_key?.S || item.partition_key || "unknown"
      }`,
      partition_key: item.partition_key?.S
        ? item.partition_key.S.split("#")[1]
        : item.partition_key?.split("#")[1] || null,
      sort_key: item.sort_key?.S
        ? item.sort_key.S.split("#")[1]
        : item.sort_key?.split("#")[1] || null,
      admin_place: item.admin_place?.S || item.admin_place || null,
      alarm: item.alarm?.S || item.alarm || null,
      category: item.category?.S || item.category || null,
      city: item.city?.S || item.city || null,
      emp_category: item.emp_category?.S || item.emp_category || null,
      emp_department: item.emp_department?.S || item.emp_department || null,
      emp_position: item.emp_position?.S || item.emp_position || null,
      emp_type: item.emp_type?.S || item.emp_type || null,
      license_plate: item.license_plate?.S || item.license_plate || null,
      place_address: item.place_address?.S || item.place_address || null,
      place_id: item.place_id?.S || item.place_id || null,
      service: item.service?.S || item.service || null,
      user_gender: item.user_gender?.S || item.user_gender || null,
      user_name: item.user_name?.S || item.user_name || null,
      user_nickname: item.user_nickname?.S || item.user_nickname || null,
      user_surname: item.user_surname?.S || item.user_surname || null,
      work_hours: item.work_hours?.S || item.work_hours || null,
      work_zones: item.work_zones?.S || item.work_zones || null,
      days_number: item.number?.S || item.number || null,
      presigned_url: item.presigned_url || null,
      start_work_time: item.start_work_time?.S || item.start_work_time || null,
      end_work_time: item.end_work_time?.S || item.end_work_time || null,
      emp_office: item.emp_office?.S || item.emp_office || null,
      emp_unit: item.emp_unit?.S || item.emp_unit || null,
      work_type: item.work_type?.S || item.work_type || null,
      work_days: formatWorkDays(item.work_days?.S || item.work_days),
      emp_subunit: item.emp_subunit?.S || item.emp_subunit || null,
      user_birth_day: item.user_birth_day?.S || item.user_birth_day || null,
      user_birth_month:
        item.user_birth_month?.S || item.user_birth_month || null,
      user_birth_year: item.user_birth_year?.S || item.user_birth_year || null,
      date_of_birth: `${
        item.user_birth_day?.S || item.user_birth_day || "__"
      }.${item.user_birth_month?.S || item.user_birth_month || "__"}.${
        item.user_birth_year?.S || item.user_birth_year || "____"
      }`,
    };
  });
};
